export default __webpack_public_path__ + "static/media/growth-chart-extra-light.e3ac7e2b.svg";